/**
 * Lightweight error reporting helper.
 *
 * In production: forwards the error to Sentry (when REACT_APP_SENTRY_DSN
 * is configured — see /app/frontend/src/instrument.js for the init flow).
 *
 * In development: also logs to the browser console so the developer can
 * inspect the stack trace inline. Production code paths must NEVER call
 * console.error directly — use this helper instead so the messages
 * actually reach an aggregator and don't pollute the user's devtools.
 */
import * as Sentry from "@sentry/react";

const IS_DEV = process.env.NODE_ENV === "development";

export function reportError(error, context = {}) {
  try {
    if (error) Sentry.captureException(error, { extra: context });
  } catch (_) {
    /* Sentry not initialised or already crashed — never block the UI. */
  }
  if (IS_DEV) {
    // eslint-disable-next-line no-console
    console.error("[reportError]", error, context);
  }
}
